import logger from './Logger';

var evMgr = (function () {

    var ev = {
        events: {},

        on: function (eventName, fn) {
            if (typeof fn == 'function') {
                if (typeof eventName == 'string') {
                    if (eventName.indexOf(',') != -1) {
                        registerArray(eventName.split(',').map(function (e) {
                            return e.trim();
                        }));
                    }
                    register(eventName)
                } else if (eventName.constructor == Array) {
                    registerArray(eventName);
                }

                function registerArray(arr) {
                    arr.forEach(function (eventName) {
                        register(eventName);
                    })
                }
                function register(eventName) {
                    ev.events[eventName] = ev.events[eventName] || [];
                    ev.events[eventName].push(fn);
                }
            }
        },

        off: function (eventName, fn) {
            if (typeof eventName == 'undefined') {
                return;
            }

            if (ev.events[eventName]) {
                if (typeof fn == 'function') {
                    for (var i = 0, length = ev.events[eventName].length; i < length; i++) {
                        if (ev.events[eventName][i] === fn) {
                            ev.events[eventName].splice(i, 1);
                            break;
                        }
                    };
                }
                else {
                    delete ev.events[eventName];
                }
            }
        },

        fire: function (eventName, data) {
            var logText = `Fire event : ${eventName}, `;
            if (ev.events[eventName]) {
                logText += ev.events[eventName].length + ' subscribers' 
                ev.events[eventName].forEach(function (fn) {
                    if (typeof data == 'undefined') {
                        data = {};
                    }
                    data.eventName = eventName;
                    fn(data);
                });
                logger.log(logText);
            } else {
                logger.error(logText += 'no subscribers');
            }
        },

        getNames: function () {
            return Object.keys(ev.events);
        }
    };

    return {
        on: ev.on,
        off: ev.off,
        fire: ev.fire,
        getEventsNames: ev.getNames
    }

})();

export default evMgr;